import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';

import Dropdown from '../../../components/dropdown/dropdown';

import { accountRoute } from '../../../routes';

import css from './editorialListItem.scss';

export default class AccountBlockCategoryList extends Component {
	static propTypes = {
		title: PropTypes.string,
		content: PropTypes.array.isRequired,
		type: PropTypes.string.isRequired,
		browser: PropTypes.object.isRequired,
		compComponent: PropTypes.oneOfType([
			PropTypes.oneOf([false]),
			PropTypes.func,
		]).isRequired,
		data: PropTypes.object,
	};

	static defaultProps = {
		title: '',
		content: [],
		type: '',
		compComponent: false,
	};

	constructor(props) {
		super();
	}

	render() {
		let Component = this.props.compComponent;

		return (
			<div className='editoriallist'>
				<aside className='span5 span5-tablet span14-mobile editoriallist__aside'>{this.props.title}</aside>
				<div className='push5 push5-tablet push0-mobile span9 span9-tablet span14-mobile editoriallist__content'>
					{(Component && this.props.content.length) && (
						this.props.content.map((item, k) => <Component key={'eitem' + k} item={item} type={this.props.type} browser={this.props.browser} data={this.props.data} />)
					) || null}
				</div>
				<div className='cf'></div>
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/account/block/categoryList.js
 **/